import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cpf"]
   connect() {
      this.cpfTarget.addEventListener('input', this.validate.bind(this));
    }

    validate() {
      const cpf = this.cpfTarget.value.replace(/\D/g, '');
      const cpfLength = 11;
      const cpfRegex = /^\d{11}$/;
      const cpfDigits = cpf.split('').map(Number);
      const cpfCheckDigits = cpfDigits.slice(-2);
      const cpfBase = cpfDigits.slice(0, -2);
      const cpfBaseLength = cpfBase.length;
      const cpfCheckDigit1 = this.calculateCheckDigit(cpfBase, 10);
      const cpfCheckDigit2 = this.calculateCheckDigit(cpfBase.concat(cpfCheckDigit1), 11);
      const isValid = cpfRegex.test(cpf) && cpfCheckDigits[0] === cpfCheckDigit1 && cpfCheckDigits[1] === cpfCheckDigit2;
      if (cpf.length !== cpfLength) {
        return;
      }
      if (isValid) {
        this.cpfTarget.classList.remove('is-invalid');
        this.cpfTarget.classList.add('is-valid');
      } else {
        this.cpfTarget.classList.add('is-invalid');
        this.cpfTarget.classList.remove('is-valid');
      }
    }

  calculateCheckDigit(digits, multiplier) {
    const sum = digits.reduce((acc, digit) => acc + digit * multiplier--, 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  }
}